import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_payment_plans`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_payment_plans/${id}`, options)
    .then(response => {
      let payment_plans = jsona.deserialize(response.data);
      delete payment_plans.links;
      return payment_plans;
    });
}

function add(payment_plans) {
  
  console.log(payment_plans);
  const payload = jsona.serialize({
    stuff: payment_plans,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_payment_plans`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(payment_plans) {
  const payload = jsona.serialize({
    stuff: payment_plans,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_payment_plans/${payment_plans.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {``
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_payment_plans/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_payment_plans/last/no`, options)
    .then(response => {
      return response.data;
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no
};

